$('.form-text').removeClass('form-text');
(function ($) {
  $(document).ready(function () {
    var subMenu = $('#contact-form-wrap').attr('value');

    $('#edit-submit').attr('value', subMenu);
		 $('.form-builder-container input').addClass('newinput');
  });
}(jQuery));
